import { gql } from 'apollo-boost';

export const GET_BY_ID = gql`
query messages($publisherId: String!) {
  messages(publisherId: $publisherId) {
      id
      publisherId
      title
      message
      url
      sendAt
      language
    }
  }  
`;

export const ADD = gql`
  mutation createMessage($publisherId: String!, $title: String!,$message: String!,$url: String!,$sendAt: DateTime,$language: String!) {
    createMessage(input: { publisherId: $publisherId, title: $title,message: $message,url: $url,sendAt: $sendAt, language: $language }) {
      id
      publisherId
      title
      message
      url
      sendAt
      language
    }
  }
`;

export const EDIT = gql`
  mutation updateMessage($id: String!, $publisherId: String!, $title: String!,$message: String!,$url: String!,$sendAt: DateTime,$language: String!) {
    updateMessage(id: $id, input: { publisherId: $publisherId, title: $title,message: $message,url: $url,sendAt: $sendAt,language: $language }) {
      id
      publisherId
      title
      message
      url
      sendAt
      language
    }
  }
`;

export const DELETE = gql`
mutation deleteMessage($id: String!) {
deleteMessage(id: $id) {
    id
  }
}
`;
